<template>
	<v-flex>
    <div class="mt-3 ml-3">
				<v-flex >
					<v-btn @click="$emit('changeConfig',0)"> konfiguruj dla oferty </v-btn>
					<v-btn @click="$emit('changeConfig',1)"> konfiguruj osobno dla każdego modułu </v-btn>
					<v-btn > relacje między modułami </v-btn>
				</v-flex>
				<v-flex>
					<v-btn @click="fullSave" primary>Zapisz</v-btn>
				</v-flex>
			</div>
				<v-flex>
			<egranty-switch-info
							v-model="moduleFinancialPercentageDotationConfig.createPercentageModuleValues"
							:aria-label="title"
							:title="title"
							:information="information"
						></egranty-switch-info>
					</v-flex>
			<v-container fluid v-if="moduleFinancialPercentageDotationConfig.createPercentageModuleValues">
					<v-layout ml-3 >
						<v-expand-transition>
						<v-layout class="ml-3">
							<v-flex xs6>
								<v-data-table
									:items="moduleFinancialPercentageDotationConfig.moduleFinancialPercentageSettings"
									:headers="tableHeaders"
									class="elevation-1"
									hide-actions>
									<template slot="items" slot-scope="props">
										<td class="text-xs-center">{{ props.item.moduleNumber }}</td>
										<td class="text-xs-center">{{ props.item.moduleNumber != 1 ? formatMoney(props.item.percentageRelativeValue) : "100" }}</td>
										<td class="text-xs-center">
											<v-icon v-if="props.item.moduleNumber != 1"
												small
												class="mr-2"
												@click="editModulePercentageValue(props.item)">
												edit
											</v-icon>
											<v-icon v-if="props.item.moduleNumber != 1 && props.item.percentageRelativeValue"
											color="lightred"
												small
												class="mr-2"
												@click="deleteModulePercentageValue(props.item)">
												delete
											</v-icon>
										</td>
									</template>
								</v-data-table>
							</v-flex>
						</v-layout>
					</v-expand-transition>

						</v-layout>
			</v-container>
			<egranty-input-field-popup
					:default-value="editedItem.percentageRelativeValue"
					:is-open.sync="editedItemDialog"
					:title="'Procentowa wartość w stosunku do 1 modułu'"
					:label="'Wartość (%)'"
					field-type="NUMBER"
					suffix="%"
					placeholder="np. 150"
					@save="saveItem"
				></egranty-input-field-popup>
				<v-dialog v-model="deletedItemDialog" width="500">
      <v-card>
        <v-form ref="form">
          <v-card-title class="headline"
            >Czy na pewno chcesz usunąć wybraną wartość?</v-card-title
          >
          <v-card-actions>
            <v-spacer />
            <v-btn @click="deleteItem" > Usuń </v-btn>
            <v-btn @click="deletedItemDialog = false"> Zamknij </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

	<v-flex>
			<egranty-switch-info
							v-model="moduleFinancialPercentageConfig.createPercentageModuleValues"
							:aria-label="titleTotalPrice"
							:title="titleTotalPrice"
							:information="informationTotalPrice"
						></egranty-switch-info>
					</v-flex>
			<v-container fluid v-if="moduleFinancialPercentageConfig.createPercentageModuleValues">
					<v-layout ml-3 >
						<v-expand-transition>
						<v-layout class="ml-3">
							<v-flex xs6>
								<v-data-table
									:items="moduleFinancialPercentageConfig.moduleFinancialPercentageSettings"
									:headers="tableHeaders"
									class="elevation-1"
									hide-actions>
									<template slot="items" slot-scope="props">
										<td class="text-xs-center">{{ props.item.moduleNumber }}</td>
										<td class="text-xs-center">{{ props.item.moduleNumber != 1 ? formatMoney(props.item.percentageRelativeValue) : "100" }}</td>
										<td class="text-xs-center">
											<v-icon v-if="props.item.moduleNumber != 1"
												small
												class="mr-2"
												@click="editModulePercentageValue(props.item)">
												edit
											</v-icon>
											<v-icon v-if="props.item.moduleNumber != 1 && props.item.percentageRelativeValue"
											color="lightred"
												small
												class="mr-2"
												@click="deleteModulePercentageValue(props.item)">
												delete
											</v-icon>
										</td>
									</template>
								</v-data-table>
							</v-flex>
						</v-layout>
					</v-expand-transition>

						</v-layout>
			</v-container>

            </v-flex>
</template>

<script>
	import EgrantySwitchInfo from "../../../../genericComponents/EgrantySwitchInfo";
	import {FinancialSettings} from "@/api/generated/FinancialSettings";
	import egrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";
	import {Numbers} from "@/utils/Numbers";

	export default {
		name: "ContestFinancialSettingsConfigForModulePercentage",
		components: {
			EgrantySwitchInfo,
			egrantyInputFieldPopup
		},
		mixins: [Numbers],
		computed: {
			information() {
				if(this.moduleFinancialPercentageDotationConfig.createPercentageModuleValues == true){
					return "Kwota dotacji, o którą oferent wnioskuje w pierwszym module oferty wpływa na kwotę, o którą może wnioskować w kolejnych modułach. Maksymalna wysokość wnioskowanej dotacji w kolejnych modułach oferty jest zależna od kwoty dotacji, o którą oferent wnioskuje w poprzednich modułach. ";
				}
				return "Kwota dotacji, o którą oferent wnioskuje w pierwszym module oferty nie wpływa na kwotę, o którą może wnioskować w kolejnych modułach. Maksymalna wysokość wnioskowanej dotacji w kolejnych modułach oferty jest niezależna od kwoty dotacji, o którą oferent wnioskuje w poprzednich modułach. ";
			},
			title(){
				if(this.moduleFinancialPercentageDotationConfig.createPercentageModuleValues == true){
					return "Wysokość wnioskowanej dotacji jest powiązana między modułami";
				}
				return "Wysokość wnioskowanej dotacji jest niezależna w każdym module";
			},
			informationTotalPrice(){
				if(this.moduleFinancialPercentageConfig.createPercentageModuleValues == true){
					return "Całkowita wartość projektu w pierwszym module oferty wpływa na dopuszczalną całkowitą wartość projektu w kolejnych modułach oferty. Maksymalna wartość projektu w kolejnych modułach oferty jest zależna od wartości projektu w poprzednich modułach.";
				}
				return "Całkowita wartość projektu w pierwszym module oferty nie wpływa na dopuszczalną całkowitą wartość projektu w kolejnych modułach oferty. Maksymalna wartość projektu w kolejnych modułach oferty jest niezależna od wartości projektu w poprzednich modułach.";
			},
			titleTotalPrice(){
				if(this.moduleFinancialPercentageConfig.createPercentageModuleValues == true){
					return "Całkowita wartość projektu jest powiązana między modułami";
				}
				return "Całkowita wartość projektu jest niezależna w każdym module";
			},
		},

		data() {
			return {
				tableHeaders: [
					{text: "Numer modułu",align: 'center', sortable: false},
					{text: "Maksymalna wartość wobec 1 modułu (%)",align: 'center', sortable: false},
					{text: "Akcje",align: 'center', sortable: false},
				],
				moduleFinancialPercentageDotationConfig: {moduleFinancialPercentageSettings:[], createPercentageModuleValues:false},
				moduleFinancialPercentageConfig: {moduleFinancialPercentageSettings:[], createPercentageModuleValues:false},
				editedItemDialog: false,
				deletedItemDialog: false,
				editedItem: {}
			};
		},
		methods: {	
			loadData(){
				FinancialSettings.getFinancialLimitsModulesPercentageDotation(this, this.$route.params.id, response => {
					this.moduleFinancialPercentageDotationConfig = response;
				});
				FinancialSettings.getFinancialLimitsModulesPercentage(this, this.$route.params.id, response => {
					this.moduleFinancialPercentageConfig = response;
				});

			},
			fullSave() {
				FinancialSettings.postFinancialLimitsModulesPercentageDotation(this,this.$route.params.id,this.moduleFinancialPercentageDotationConfig, successResponse => {
					this.$messagesBus.$emit("success", "Zmiany zostały pomyślnie zapisane", successResponse);
					this.loadData();
				});
				FinancialSettings.postFinancialLimitsModulesPercentage(this,this.$route.params.id,this.moduleFinancialPercentageConfig, successResponse => {
					this.$messagesBus.$emit("success", "Zmiany zostały pomyślnie zapisane", successResponse);
					this.loadData();
				});
			},
			editModulePercentageValue(item){
				this.editedItem = item;
				this.editedItemDialog = true;
			},
			deleteModulePercentageValue(item){
				this.editedItem = item;
				this.deletedItemDialog = true;
			},
			saveItem(value) {
				value = value.replace(",", ".");
				value = parseFloat(value);
				if (isNaN(value) || value < 0) {
					return;
				}
				this.editedItem.percentageRelativeValue = Math.round(value * 100) / 100;
				this.editedItem = {};
				this.editedItemDialog = false;
			},
			deleteItem(){
				this.editedItem.percentageRelativeValue = null;
				this.editedItem = {};
				this.deletedItemDialog = false;

			}
		},
	
		mounted() {
			this.loadData();
		},
	};
</script>

<style scoped>

</style>
